<template>
  <base-create-form
    :create-form="createForm"
    :formTitle="formTitle"
    @submitForm="submitForm"
    @cancel="cancel"
  ></base-create-form>
</template>

<script>
import { BaseCreateForm } from "@/components/Base/index.js";
import sanitizer from "sanitizer";
import { UniversityTypeService } from "../../../services/universityType.service";
export default {
  name: "UniversityTypeCreateForm",
  components: { BaseCreateForm },
  data() {
    return {
      formTitle: this.$t("page_title.university_type_create"),
      createForm: [
        {
          label: this.$t("university_type.name"),
          name: "name",
          value: "",
          type: "input",
          required: true,
          validateRule: "required"
        },
        {
          label: this.$t("university_type.description"),
          name: "description",
          value: "",
          type: "input",
          required: false,
          validateRule: ""
        }
      ]
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: "UniversityTypeList" });
    },
    async submitForm(params) {
      const response = await new UniversityTypeService().create(params);
      if (!response) return;
      this.$notify({
        title: this.$t("common.created"),
        text: this.$t("common.created_text", {
          name: this.$t("university_type.name"),
          value: sanitizer.escape(response.name)
        }),
        type: "success"
      });
      setTimeout(() => this.$router.push({ name: "UniversityTypeList" }), 500);
    }
  }
};
</script>

<style scoped></style>
